export default class AdditionnalMetadata {
    public name: string;
    public alias: string;
    public value: string;

    public constructor() {
        this.name = "";
        this.alias = "";
        this.value = "";
    }
}